class HeaderPrincipal extends HTMLElement {
  constructor() {
    super();
    this.resultadosBusqueda = [];
    this.sucursal = GestionSucursales.corroborarInfoShopify(
      window.sucursales,
      JSON.parse(localStorage.getItem("sucursal-informacion"))
    );
    this.usuario = JSON.parse(localStorage.getItem('ph-datos-usuario')) || null;
    this.metodoEntrega = localStorage.getItem('ph-metodo-entrega') || null;
    this.itemsResultadosBusqueda = null;
    this.cantidadDesplazamiento = 400;
    this.productosEncontrados = null;
    this.abortController = null;
    this.cacheResultados = new Map();
    this.DEBOUNCE_TIME = 200;
  }

  connectedCallback() {
    this.inicializarReferencias();
    this.inicializarEventos();
    this.verificarEstadoSesion();
    this.verificarEstadoEntrega();
  }

  inicializarReferencias() {
    this.btnMenuColecciones = this.querySelector('#btn-menu-colecciones');
    this.btnOnSesion = this.querySelector('#btn-on-sesion');
    this.btnOffSesion = this.querySelector('#btn-off-sesion');
    this.btnMenuClienteMobile = this.querySelector('#menu-cliente-mobile');
    this.btnSeleccionMetodoEntrega = this.querySelector('#btn-sin-metodo-entrega');
    this.btnDominicilio = this.querySelector('#btn-metodo-domicilio');
    this.btnLocal = this.querySelector('#btn-metodo-local');

    this.contenedorInputBusqueda = this.querySelector('#h-container-input-search');
    this.inputBusqueda = this.querySelector('#h-input-buscar');
    this.fondoOscuroBusqueda = this.querySelector('#fondo-oscuro-busqueda');
    this.menuBusqueda = this.querySelector('#menu-busqueda');
    this.tituloMenuBusqueda = this.querySelector('#menu-titulo');
    this.mensajeSinResultados = this.querySelector('#mensaje-sin-resultados');
    this.productosRecomendados = this.querySelector('#productos-recomendados');
    this.productosEncontrados = this.querySelector('#productos-encontrados');
    this.btnSectorBusqueda = this.querySelector('#btn-sector-busqueda');

    this.menuColecciones = this.querySelector('#menu-colecciones');
    this.btnsColeccionesMenu = this.querySelectorAll('#btn-coleccion-menu');
    this.contenedorOpcionesMenu = this.querySelector('#contenedor-opciones-menu');
    this.btnLeftScroll = this.querySelector('#btn-left-scroll');
    this.btnRightScroll = this.querySelector('#btn-right-scroll');

    // MENU DESKTOP
    this.menuClienteDesktop = this.querySelector('#menu-cliente-desktop');
    this.btnMiPerfilDesktop = this.querySelector('#opcion-mi-perfil-desktop');
    this.btnHistorialDesktop = this.querySelector('#opcion-historial-desktop');
    this.btnCuponesYDescuentosDesktop = this.querySelector('#opcion-cupones-descuentos-desktop');
    this.btnMisPreferenciasDesktop = this.querySelector('#opcion-mis-preferencias-desktop');
    this.btnConfiguracionesDesktop = this.querySelector('#opcion-configuracion-desktop');
    this.btnCerrarSesionDesktop = this.querySelector('#opcion-cerrar-sesion-desktop');
    this.btnDesktopSucursales = this.querySelector('#btn-desktop-sucursales');

    // MENU MOBILE
    this.btnHamburguesaMobile = this.querySelector('#btn-menu-mobile');
    this.menuClienteMobile = this.querySelector('#menu-cliente-mobile');
    this.btnMiPerfilMobile = this.querySelector('#opcion-mi-perfil-mobile');
    this.btnHistorialMobile = this.querySelector('#opcion-historial-mobile');
    this.btnCuponesYDescuentosMobile = this.querySelector('#opcion-cupones-descuentos-mobile');
    this.btnMisPreferenciasMobile = this.querySelector('#opcion-mis-preferencias-mobile');
    this.btnConfiguracionesMobile = this.querySelector('#opcion-configuracion-mobile');
    this.btnCerrarSesionMobile = this.querySelector('#opcion-cerrar-sesion-mobile');
    this.btnsMobileSucursales = this.querySelectorAll('#btn-mobile-sucursales');

    this.btnCerrarMenuMobile = this.querySelector('#h-boton-cerrar-menu-mobile');
    this.menuClienteMobileBody = this.querySelector('#menu-cliente-mobile-body');

    // Contenedores de opciones
    this.opcionesConSesion = this.querySelectorAll('.opcion-con-sesion');
    this.opcionesSinSesion = this.querySelectorAll('.opcion-sin-sesion');
  }

  inicializarEventos() {
    this.inputBusqueda.addEventListener('focus', this.inputBuquedaFocus.bind(this));
    this.inputBusqueda.addEventListener('input', this.inputBusquedaEscribir.bind(this));

    // Cerrar menú de búsqueda cuando se hace click explícito en el fondo oscuro
    this.fondoOscuroBusqueda.addEventListener('click', this.cerrarMenuYFondoOscuroBusqueda.bind(this));
    this.btnsColeccionesMenu.forEach((coleccion) => {
      coleccion.addEventListener('click', this.redireccionarColeccionMenu.bind(this, coleccion));
    });
    this.btnMenuColecciones.addEventListener('click', this.mostrarMenuDesplegable.bind(this));
    this.btnSectorBusqueda.addEventListener('click', this.botonSectorBusqueda.bind(this));

    this.btnLeftScroll.addEventListener('click', this.desplazarIzquierdaHeader.bind(this));
    this.btnRightScroll.addEventListener('click', this.desplazarDerechaHeader.bind(this));

    // EVENTOS DESKTOP
    this.btnOnSesion.addEventListener('click', this.verMenuDesktop.bind(this));
    this.btnMiPerfilDesktop.addEventListener('click', this.opcionesMenuDesktop.bind(this, 'mi-perfil'));
    this.btnHistorialDesktop.addEventListener('click', this.opcionesMenuDesktop.bind(this, 'historial'));
    this.btnCuponesYDescuentosDesktop.addEventListener('click', this.opcionesMenuDesktop.bind(this, 'cupones-y-descuentos'));
    this.btnMisPreferenciasDesktop.addEventListener('click', this.opcionesMenuDesktop.bind(this, 'mis-preferencias'));
    this.btnConfiguracionesDesktop.addEventListener('click', this.opcionesMenuDesktop.bind(this, 'configuraciones'));
    this.btnCerrarSesionDesktop.addEventListener('click', this.opcionesMenuDesktop.bind(this, 'cerrar-sesion'));
    this.btnDesktopSucursales.addEventListener('click', this.scrollToSucursales.bind(this));

    // EVENTOS MOBILE
    this.btnHamburguesaMobile.addEventListener('click', this.verMenuMobile.bind(this));
    this.btnMiPerfilMobile.addEventListener('click', this.opcionesMenuMobile.bind(this, 'mi-perfil'));
    this.btnHistorialMobile.addEventListener('click', this.opcionesMenuMobile.bind(this, 'historial'));
    this.btnCuponesYDescuentosMobile.addEventListener('click', this.opcionesMenuMobile.bind(this, 'cupones-y-descuentos'));
    this.btnMisPreferenciasMobile.addEventListener('click', this.opcionesMenuMobile.bind(this, 'mis-preferencias'));
    this.btnConfiguracionesMobile.addEventListener('click', this.opcionesMenuMobile.bind(this, 'configuraciones'));
    this.btnCerrarSesionMobile.addEventListener('click', this.opcionesMenuMobile.bind(this, 'cerrar-sesion'));
    this.btnsMobileSucursales.forEach(btn => {
      btn.addEventListener('click', this.scrollToSucursales.bind(this));
    });

    this.btnCerrarMenuMobile.addEventListener('click', this.cerrarMenuMobile.bind(this));

    // Detectar clicks fuera del menú desktop
    document.addEventListener('click', this.manejarClickFueraMenuDesktop.bind(this));

    // Detectar clicks fuera del menú de búsqueda (solo desktop)
    document.addEventListener('click', this.manejarClickFueraBusqueda.bind(this));
  }

  scrollToSucursales() {
    this.menuClienteMobile.style.display = 'none';
    const sucursalesInfo = document.querySelector('.ds-contenedor-base');
    if (sucursalesInfo) {
      sucursalesInfo.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }
  }

  verificarEstadoSesion() {
    if (this.usuario == null) {
      // SIN SESIÓN - DESKTOP
      this.btnOffSesion.style.display = 'flex';
      this.btnOnSesion.style.display = 'none';

      // SIN SESIÓN - MOBILE
      this.opcionesConSesion.forEach(opcion => {
        opcion.style.display = 'none';
      });
      this.opcionesSinSesion.forEach(opcion => {
        opcion.style.display = 'flex';
      });
    } else {
      // CON SESIÓN - DESKTOP
      this.btnOffSesion.style.display = 'none';
      this.btnOnSesion.style.display = 'flex';

      // CON SESIÓN - MOBILE
      this.opcionesConSesion.forEach(opcion => {
        opcion.style.display = 'flex';
      });
      this.opcionesSinSesion.forEach(opcion => {
        opcion.style.display = 'none';
      });
    }

    if (this.menuClienteMobileBody) {
      this.menuClienteMobileBody.style.display = 'flex';
    }
  }

  verificarEstadoEntrega() {
    if (this.metodoEntrega == null || this.metodoEntrega == 'no') {
      this.btnSeleccionMetodoEntrega.style.display = 'flex';
    } else {
      this.btnSeleccionMetodoEntrega.style.display = 'none';
      if (this.metodoEntrega == 'local') {
        this.btnLocal.style.display = 'flex';
        this.btnDominicilio.style.display = 'none';
      }

      if (this.metodoEntrega == 'domicilio') {
        this.btnDominicilio.style.display = 'flex';
        this.btnLocal.style.display = 'none';
      }
    }
  }

  mostrarMenuDesplegable() {
    const estaSeleccionado = this.menuColecciones.classList.contains('seleccionado');
    if (estaSeleccionado) {
      this.menuColecciones.classList.remove('seleccionado');
      this.menuColecciones.style.left = '300%';
    } else {
      this.menuColecciones.classList.add('seleccionado');
      this.menuColecciones.style.left = '0';

      setTimeout(() => this.verificarBotonesHeader(), 100);
    }
  }

  inputBuquedaFocus() {
    // En mobile no usamos este menú, se redirige a /search
    if (window.innerWidth < 768) {
      return;
    }

    // Mostrar el menú
    this.fondoOscuroBusqueda.style.display = 'flex';
    this.menuBusqueda.style.display = 'flex';
    // Bloquear scroll de la página mientras el menú está abierto
    document.body.style.overflow = 'hidden';

    this.menuBusqueda.classList.add('abriendo');
    setTimeout(() => {
      this.menuBusqueda.classList.remove('abriendo');
    }, 300);

    // Verificar si el input está vacío y restaurar estado inicial
    const inputValue = this.inputBusqueda.value.trim();
    if (inputValue.length === 0) {
      this.tituloMenuBusqueda.textContent = 'Descubrí más opciones';
      this.mensajeSinResultados.style.display = 'none';
      this.productosEncontrados.style.display = 'none';
      this.productosRecomendados.style.display = 'grid';
      this.btnSectorBusqueda.querySelector('p').textContent = 'EXPLORAR MENÚ';
    }

    // Agregar eventos a productos existentes
    this.itemsResultadosBusqueda = this.querySelectorAll('.producto-item');
    this.itemsResultadosBusqueda.forEach((item) => {
      item.addEventListener('click', async () => GestorProductos.evaluarDisponibilidadProducto(item.dataset.titulo));
    });
  }

  async inputBusquedaEscribir() {
    // PASO 1: Limpiar timeout anterior
    clearTimeout(this.debounceTimeout);

    // PASO 2: Cancelar petición anterior si existe
    if (this.abortController) {
      this.abortController.abort();
    }

    // PASO 3: Crear nuevo timeout de 200ms (más rápido que 300ms)
    this.debounceTimeout = setTimeout(async () => {
      const inputValue = this.inputBusqueda.value.trim();

      // Si está vacío, restaurar estado inicial completo
      if (inputValue.length == 0) {
        this.tituloMenuBusqueda.textContent = 'Descubrí más opciones';
        this.mensajeSinResultados.style.display = 'none';
        this.productosEncontrados.style.display = 'none';
        this.productosRecomendados.style.display = 'grid';
        this.btnSectorBusqueda.querySelector('p').textContent = 'EXPLORAR MENÚ';
        return;
      }

      try {
        // PASO 4: Crear nuevo AbortController para esta búsqueda
        this.abortController = new AbortController();

        // PASO 5: Realizar la búsqueda con señal de cancelación
        const respuesta = await GestorProductos.buscarProductosShopify(inputValue, this.abortController.signal);

        // PASO 6: Crear el HTML de los resultados
        let htmlResultados = '';

        respuesta.forEach(item => {
          console.log('item', item);
          const tieneDescuento = item.precio_comparacion && item.precio_comparacion > item.precio;
          const porcentajeDescuento = tieneDescuento
            ? Math.round(((item.precio_comparacion - item.precio) / item.precio_comparacion) * 100)
            : 0;

          htmlResultados += `
            <div class="producto-item" data-titulo="${item.nombre}">
              <div class="producto-item-descuento" style="display: ${tieneDescuento ? 'flex' : 'none'};">
                <p>-${porcentajeDescuento}%</p>
              </div>
  
              <div class="producto-item-imagen">
                <a
                  class="producto-item-imagen"
                  aria-label="Ver detalles de ${item.nombre}"
                >
                  <img
                    src="${item.imagen}"
                    alt="${item.nombre}"
                    loading="lazy"
                    width="100%"
                    height="100%"
                  >
                </a>
              </div>
  
              <div class="producto-item-detalle">
                <a>
                  <h3>${item.nombre}</h3>
                </a>
                <div class="producto-item-precios">
                  <h3 class="color-letras-primary">${item.precio} BS</h3>
                  ${tieneDescuento ? `
                    <h4 class="color-letras-precioCS" style="text-decoration: line-through;">
                      ${item.precio_comparacion} BS
                    </h4>
                  ` : ''}
                </div>
              </div>
            </div>
          `;
        });

        // PASO 7: Insertar el HTML y mostrar
        this.productosEncontrados.innerHTML = htmlResultados;
        this.productosEncontrados.style.display = 'grid';

        // PASO 8: Agregar eventos a los items
        this.itemsResultadosBusqueda = this.querySelectorAll('.producto-item');
        this.itemsResultadosBusqueda.forEach((item) => {
          item.addEventListener('click', async () => GestorProductos.evaluarDisponibilidadProducto(item.dataset.titulo));
        });

        // PASO 9: Mostrar con o sin resultados
        if (htmlResultados.length == 0) {
          this.tituloMenuBusqueda.textContent = 'Sin Resultados (0)';
          this.mensajeSinResultados.style.display = 'flex';
          this.productosEncontrados.style.display = 'none';
          this.productosRecomendados.style.display = 'none';
          this.btnSectorBusqueda.querySelector('p').textContent = 'EXPLORAR MENÚ';
        } else {
          this.tituloMenuBusqueda.textContent = `Resultados de "${inputValue}" (${respuesta.length})`;
          this.mensajeSinResultados.style.display = 'none';
          this.productosEncontrados.style.display = 'grid';
          this.productosRecomendados.style.display = 'none';
          this.btnSectorBusqueda.querySelector('p').textContent = 'VER MAS';
        }

      } catch (error) {
        // No mostrar error si fue cancelación intencional
        if (error.name !== 'AbortError') {
          console.error('Error al procesar la búsqueda:', error);
          this.productosEncontrados.style.display = 'none';
        }
      }
    }, 200); // Reducido de 300ms a 200ms
  }

  cerrarMenuYFondoOscuroBusqueda() {
    // Agregar animación de salida
    this.menuBusqueda.classList.add('cerrando');

    setTimeout(() => {
      this.fondoOscuroBusqueda.style.display = 'none';
      this.menuBusqueda.style.display = 'none';
      this.menuBusqueda.classList.remove('cerrando');
      // Restaurar scroll de la página
      document.body.style.overflow = '';

      // NUEVO: Limpiar input y restaurar estado inicial
      this.inputBusqueda.value = '';
      this.tituloMenuBusqueda.textContent = 'Descubrí más opciones';
      this.mensajeSinResultados.style.display = 'none';
      this.productosEncontrados.style.display = 'none';
      this.productosRecomendados.style.display = 'grid';
      this.btnSectorBusqueda.querySelector('p').textContent = 'EXPLORAR MENÚ';

      // Cancelar cualquier búsqueda pendientee
      clearTimeout(this.debounceTimeout);
      if (this.abortController) {
        this.abortController.abort();
      }
    }, 300);
  }

  verMenuDesktop() {
    const estaAbierto = this.menuClienteDesktop.style.display == 'flex';

    if (this.usuario == null) {
      return;
    }

    if (estaAbierto) {
      this.cerrarMenuDesktop();
    } else {
      this.menuClienteDesktop.style.display = 'flex';
      // NUEVO: Agregar clase para animación
      this.menuClienteDesktop.classList.add('abriendo');
      setTimeout(() => {
        this.menuClienteDesktop.classList.remove('abriendo');
      }, 300);
    }
  }

  opcionesMenuDesktop(opcion) {
    switch (opcion) {
      case 'mi-perfil':
        localStorage.setItem('pg-perfil-opcion', 'perfil');
        window.location.href = '/pages/perfil';
        break;
      case 'historial':
        localStorage.setItem('pg-perfil-opcion', 'historial');
        window.location.href = '/pages/perfil';
        break;
      case 'cupones-y-descuentos':
        window.location.href = '/pages/perfil';
        break;
      case 'mis-preferencias':
        window.location.href = '/pages/error-1';
        break;
      case 'configuraciones':
        localStorage.setItem('pg-perfil-opcion', 'configuracion');
        window.location.href = '/pages/perfil';
        break;
      case 'cerrar-sesion':
        localStorage.removeItem('ph-datos-usuario');
        localStorage.removeItem("ph-tipo-usuario");
        localStorage.removeItem('pg-perfil-opcion');
        window.location.href = '/';
        break;
      default:
        console.error('Opción no válida:', opcion);
        break;
    }

    this.menuClienteDesktop.style.display = 'none';
  }

  verMenuMobile() {
    const announcementBar = document.querySelector('.announcement-bar-custom');

    if (this.menuClienteMobile.style.display == 'flex') {
      this.menuClienteMobile.style.display = 'none';
      document.body.style.overflow = '';
      // Mostrar announcement-bar
      if (announcementBar) announcementBar.style.display = '';
    } else {
      this.menuClienteMobile.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      // Ocultar announcement-bar
      if (announcementBar) announcementBar.style.display = 'none';
    }
  }

  cerrarMenuMobile() {
    const announcementBar = document.querySelector('.announcement-bar-custom');
    this.menuClienteMobile.style.display = 'none';
    document.body.style.overflow = '';
    // Mostrar announcement-bar
    if (announcementBar) announcementBar.style.display = '';
  }

  opcionesMenuMobile(opcion) {
    // Cerrar el menú mobile
    this.menuClienteMobile.style.display = 'none';
    document.body.style.overflow = '';

    // Ejecutar acción según opción
    switch (opcion) {
      case 'mi-perfil':
        localStorage.setItem('pg-perfil-opcion', 'perfil');
        window.location.href = '/pages/perfil';
        break;
      case 'historial':
        localStorage.setItem('pg-perfil-opcion', 'historial');
        window.location.href = '/pages/historial';
        break;
      case 'cupones-y-descuentos':
        localStorage.setItem('pg-perfil-opcion', 'cupones-y-descuentos');
        window.location.href = '/pages/cupones-y-descuentos';
        break;
      case 'mis-preferencias':
        localStorage.setItem('pg-perfil-opcion', 'mis-preferencias');
        window.location.href = '/pages/mis-preferencias';
        break;
      case 'configuraciones':
        localStorage.setItem('pg-perfil-opcion', 'configuraciones');
        window.location.href = '/pages/configuraciones';
        break;
      case 'cerrar-sesion':
        localStorage.removeItem('ph-datos-usuario');
        localStorage.removeItem("ph-tipo-usuario");
        localStorage.removeItem('pg-perfil-opcion');
        window.location.href = '/';
        break;
    }
  }


  manejarClickFueraMenuDesktop(event) {
    // Verificar si el menú está visible
    if (this.menuClienteDesktop.style.display !== 'flex') {
      return;
    }

    // Verificar si el click fue dentro del botón o del menú
    const dentroDelBoton = this.btnOnSesion.contains(event.target);
    const dentroDelMenu = this.menuClienteDesktop.contains(event.target);

    // Si el click fue fuera de ambos elementos, cerrar
    if (!dentroDelBoton && !dentroDelMenu) {
      this.cerrarMenuDesktop();
    }
  }

  cerrarMenuDesktop() {
    this.menuClienteDesktop.classList.add('cerrando');

    setTimeout(() => {
      this.menuClienteDesktop.style.display = 'none';
      this.menuClienteDesktop.classList.remove('cerrando');
    }, 300); // Duración de la animación
  }

  manejarClickFueraBusqueda(event) {
    // Solo aplica en desktop
    if (window.innerWidth < 768) {
      return;
    }

    // Verificar si el menú está visible
    if (this.menuBusqueda.style.display !== 'flex') {
      return;
    }

    // Verificar si el click fue dentro del input, contenedor del input o menú de búsqueda
    const dentroDelInput = this.inputBusqueda.contains(event.target);
    const dentroDelContenedorInput = this.contenedorInputBusqueda
      ? this.contenedorInputBusqueda.contains(event.target)
      : false;
    const dentroDelMenu = this.menuBusqueda.contains(event.target);

    // Si el click fue fuera del input, del contenedor del input y del menú, cerrar
    if (!dentroDelInput && !dentroDelContenedorInput && !dentroDelMenu) {
      this.cerrarMenuYFondoOscuroBusqueda();
    }
  }

  redireccionarColeccionMenu(elementoBase) {
    const dataElemento = elementoBase.dataset.menu;
    window.location.href = `/pages/_menu-1?coleccion=${dataElemento}`;
  }

  // Método para desplazar a la izquierda
  desplazarIzquierdaHeader() {
    // Verificar que el contenedor existe
    if (!this.contenedorOpcionesMenu) {
      console.error("Error: this.contenedorOpcionesMenu es undefined");
      return;
    }

    // Desplaza el contenedor
    this.contenedorOpcionesMenu.scrollBy({
      left: -this.cantidadDesplazamiento,
      behavior: 'smooth'
    });

    // Verificar los botones después del desplazamiento
    setTimeout(() => {
      this.verificarBotonesHeader();
    }, 500);
  }

  // Método para desplazar a la derecha
  desplazarDerechaHeader() {

    // Verifica que el contenedor existe
    if (!this.contenedorOpcionesMenu) {
      console.error("Error: this.contenedorOpcionesMenu es undefined");
      return;
    }

    // Desplaza el contenedor
    this.contenedorOpcionesMenu.scrollBy({
      left: this.cantidadDesplazamiento,
      behavior: 'smooth'
    });

    // Verifica los botones después del desplazamiento
    setTimeout(() => this.verificarBotonesHeader(), 300);
  }

  // Método para verificar la visibilidad de los botones
  verificarBotonesHeader() {
    // Verificar si el contenedor existe
    if (!this.contenedorOpcionesMenu) {
      console.error("Error: this.contenedorOpcionesMenu es undefined");
      return;
    }

    // Comprobar inicio
    if (this.contenedorOpcionesMenu.scrollLeft <= 0) {
      this.btnLeftScroll.style.opacity = "0.5";
      this.btnLeftScroll.style.pointerEvents = "none";
    } else {
      this.btnLeftScroll.style.opacity = "1";
      this.btnLeftScroll.style.pointerEvents = "auto";
    }

    // Comprobar final
    if (this.contenedorOpcionesMenu.scrollLeft + this.contenedorOpcionesMenu.clientWidth >= this.contenedorOpcionesMenu.scrollWidth - 10) {
      this.btnRightScroll.style.opacity = "0.5";
      this.btnRightScroll.style.pointerEvents = "none";
    } else {
      this.btnRightScroll.style.opacity = "1";
      this.btnRightScroll.style.pointerEvents = "auto";
    }
  }

  // BOTON DEL MENU DE RESULTADOS DE BUSQUEDA (LOGICA)
  botonSectorBusqueda() {
    const texto = this.inputBusqueda.value.trim();
    if (texto.length > 0) {
      localStorage.setItem('ph-busqueda-query', texto);
      window.location.href = '/search';
    } else {
      window.location.href = '/pages/_menu-1?coleccion=Todo';
    }
  }
}

customElements.define('header-principal', HeaderPrincipal);

document.addEventListener('DOMContentLoaded', function () {
  function updateHeaderPosition() {
    const announcementBar = document.querySelector('.announcement-bar-custom');
    const header = document.querySelector('header-principal');

    if (announcementBar && header) {
      const announcementHeight = announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
  }

  // Ejecutar al cargar y al redimensionar
  updateHeaderPosition();
  window.addEventListener('resize', updateHeaderPosition);
});